import React, { Component } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import LoginValidator from '../../validators/LoginValidator'
import InputField from '../Inputs/InputField'
import {sections} from '../../utils/variables'
import {Link} from 'react-router-dom'
class PageForm extends Component {

    constructor(props) {
	super(props);
	this.state = {
	    waiting: false,
	    authorized: undefined
	}
    }
    
    componentDidMount(){


    }
    
    render() {
	const { handleSubmit, successAction, logout, authenticated } = this.props
	let {authorized, waiting} = this.state;
	const submit = (values, dispatch, props) => {
	    let errors = LoginValidator( values, props ) || {};
	    
	    waiting=true;
	    this.setState({ waiting})
	    if (Object.keys(errors).length) {
		throw new SubmissionError(errors);
	    } else {		
		props.login(values).then((res) => {
		    waiting=false;
		    authorized = true;
		    this.setState({authorized, waiting})
		}).catch((err) => {		    
		    authorized = false;
		    waiting = false;
		    this.setState({authorized, waiting})
		})
	    }
	}

	
	return (
	    <div>
		{

		    authenticated ?
		    
		    <button  onClick={logout} style={{width: '100%'}} >Log Out</button>
		    :
		    <div>
			<form onSubmit={handleSubmit(submit)}>
			    <h3 style={{display: (authorized===false && !waiting ? 'block' : 'none') }}>Napacno geslo</h3>
			    
			    <InputField name="email" type="text" label="email" />
			    <InputField name="password" type="password" label="password" />

			    <button type="submit" disabled={this.props.invalid} className="btn btn-brown btn-big full-width"><i style={{display: (this.state.waiting ? 'inline-block' : 'none' )}} className="fa fa-spinner fa-spin"></i> Login</button>
			</form>
			<Link  to="/passwordReset">
			    <button type="button" className="btn btn-brown btn-big full-width">Izgubil sem geslo</button>
			  </Link>
		    </div> 
		}
	    </div>
	);
    }
}

export default reduxForm({
    form: 'page',
    validate: LoginValidator,
    enableReinitialize: true
})(PageForm);



// WEBPACK FOOTER //
// ./src/components/Login/index.jsx